import { Theme } from '@/components/Block'
import GsuLoader from '@/components/GsuLoader'
import { UnitSize } from '@/constants/measured-scope'
import { SectionNavigationAction } from '@/shared/api-generated-types'
import { CLassMetaData } from '@/widgets/v2/AI/Chat/Message'
import CardRow from '@/widgets/v2/CardRow'
import SessionCard from '@/widgets/v2/SessionCard'
import VODClassCard, { Props as VODClassCardProps } from '@/widgets/v2/VODClassCard'

type CarouselOptions = false | UnitSize[] | 'always'

export interface HelenResponseSessionCardRowProps {
  title?: string | null
  subtitle?: string | null
  theme?: Theme
  carousel?: CarouselOptions
  items: Partial<CLassMetaData>[]
  className?: string
  navigationActions?: SectionNavigationAction[]
  fetching?: boolean
}
export type DeviceSizes = {
  [key in UnitSize]: boolean | undefined
}

const HelenResponseSessionCardRow = ({
  title,
  subtitle,
  theme = 'white',
  navigationActions,
  items,
  className = '',
  fetching,
}: HelenResponseSessionCardRowProps): JSX.Element => {
  if (fetching) return <GsuLoader consumeSpace />

  const classCards = items.length
    ? items.map((item) => {
        return item.hasSessions ? (
          <SessionCard {...(item as CLassMetaData)} key={`class_${item.id}`} />
        ) : (
          <VODClassCard {...(item as VODClassCardProps)} key={`class_${item.id}`} />
        )
      })
    : []

  return (
    <CardRow
      title={title}
      subtitle={subtitle}
      theme={theme}
      navigationActions={navigationActions}
      className={className}
    >
      {classCards}
    </CardRow>
  )
}

export default HelenResponseSessionCardRow
